<template>
  <div class="reelbuzz-menu">
    <div class="reelbuzz-content">
      <div class="reelbuzz-left">
        <img src="../assets/logo.png" class="logo" @click="changeIndex" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    changeIndex() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>
<style lang="less" scoped>
.reelbuzz-menu {
  position: relative;
  z-index: 1;

  .reelbuzz-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 360px;
    height: 100px;

    .reelbuzz-left {
      cursor: pointer;
      display: flex;
      align-items: center;

      .logo {
        width: 147px;
        height: 36px;
      }
    }


  }
}
</style>
